import axios from "../../../api/axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import {
  getTableConfig,
  DEFAULT_PAGINATION,
  STATUS_UPDATE_CONFIG,
  TABLE_TYPES,
} from "../config/tableConfig";
import { endpoints } from "../../../api/endpoint";

export const useTableData = (tableType, filters, limit, offset) => {
  const config = getTableConfig(tableType);

  return useQuery({
    queryKey: [tableType, filters, limit, offset],
    queryFn: async () => {
      const params = {
        limit,
        offset,
      };

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          params[key] = value;
        }
      });

      const response = await axios.get(config.apiEndpoint, { params });

      return {
        data: response.data?.data || [],
        pagination: response.data?.pagination || DEFAULT_PAGINATION,
        statusCounts: response.data?.statusCounts || null,
        onboardingStatusCounts: response.data?.onboardingStatusCounts || null,
      };
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useUpdateTableStatus = (tableType) => {
  const { endpoint, buildPayload } = STATUS_UPDATE_CONFIG[tableType] || {};

  return useMutation({
    mutationFn: async ({ id, status, updatedBy }) => {
      if (!endpoint) {
        throw new Error(
          `No status-update endpoint configured for "${tableType}"`,
        );
      }

      let payload = buildPayload({ status, updatedBy });

      if (tableType === TABLE_TYPES.LEADS) {
        payload = { onboardingStatus: status, updatedBy };
      }

      const response = await axios.patch(`${endpoint}/${id}`, payload);
      return response.data;
    },
  });
};

export const extractDynamicOptions = (dataList, fieldKey) => {
  if (!dataList || dataList.length === 0) {
    return [];
  }

  const uniqueValues = [...new Set(dataList.map((item) => item[fieldKey]))];
  return uniqueValues
    .filter((value) => value && value !== "--")
    .map((value) => ({
      label: value,
      value: value,
    }));
};
